module.exports = __webpack_public_path__ + "static/media/bfc.b0c3074e.png";